import React from 'react';

/**
 * Toasts — presentational stack for MCPlayback action feedback (2c). Driven by useToasts (action
 * feedback + Undo) and, in the View, the in-flight clip downloads mapped to the same shape. Pure: it
 * renders whatever array it is given and calls back on Undo / close.
 *
 * Each toast: { id, message, tone:'info'|'success'|'error', undoLabel?, onUndo?, dismissable? }.
 * Undo runs onUndo then dismisses. The close (×) shows only for dismissable toasts (download-progress
 * toasts auto-expire and are not manually dismissable). Scoped under .mcplayback-container via the
 * .mcpb-toasts class (CRA bundles CSS globally).
 */
const Toasts = ({ toasts = [], onDismiss }) => {
  if (!toasts.length) return null;
  return (
    <div className="mcpb-toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`mcpb-toast mcpb-toast--${t.tone || 'info'}`}>
          <span className="mcpb-toast__msg">{t.message}</span>
          {t.undoLabel && t.onUndo && (
            <button
              type="button"
              className="mcpb-toast__undo"
              onClick={() => { t.onUndo(); if (onDismiss) onDismiss(t.id); }}
            >
              {t.undoLabel}
            </button>
          )}
          {t.dismissable !== false && onDismiss && (
            <button
              type="button"
              className="mcpb-toast__close"
              aria-label="Dismiss"
              onClick={() => onDismiss(t.id)}
            >
              &#215;
            </button>
          )}
          {typeof t.progress !== 'undefined' && (
            <div
              className="mcpb-toast__bar"
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={t.progress == null ? undefined : t.progress}
            >
              <div
                className={`mcpb-toast__bar-fill${t.progress == null ? ' mcpb-toast__bar-fill--indeterminate' : ''}`}
                style={t.progress == null ? undefined : { width: `${t.progress}%` }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Toasts;
